import styled from 'styled-components/native';
import { Text } from 'react-native';

import { FOHColors } from '../colors/FOHColors';

import { FOHFonts } from './FOHFonts';

export const FOHSectionLabel = styled(Text)`
  font-family: ${FOHFonts.MEDIUM};
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 200%;
  align-items: center;
  color: ${FOHColors.GRAYSCALE_G1};
`;
